import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ContentCutIcon(props: IconProps) {
    return <Icon {...props} iconKey={"content_cut"}/>
}
